import React, { useEffect, useRef, useState } from "react";
import { LuSearch } from "react-icons/lu";
import inputIcon from "../../src/assets/images/SearchIc.svg";
import { FaRegUser } from "react-icons/fa";
import { getFetcher, postFetcher } from "../../api/fetchers";
import { endpoints } from "../../api/endpoints";
import { Link, useNavigate } from "react-router-dom";
import { FaCaretRight } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { useLanguage } from "../context/LanguageContext";

interface IProps {
  type: string;
}

const SearchInput: React.FC<IProps> = ({ type }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setShowCategory(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [searchValue, setSearchValue] = React.useState("");
  const [selectedCategoryId] = React.useState("1");
  const [searchResults, setSearchResults]: any = React.useState([]);
  const [complainResults, setComplainResults] = React.useState([]);
  const [allComplains, setAllComplains] = useState<any>();
  const [showCategory, setShowCategory] = useState<boolean>(false);
  const [showSubCategory, setShowSubCategory] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [subCategories, setSubCategories] = useState<any>([]);

  const searchFunc = async () => {
    if (!searchValue) setSearchResults([]);
    try {
      const response = await postFetcher(endpoints.products.searchProducts, {
        arg: {
          searchText: searchValue,
          categoryId: selectedCategoryId,
          pageNumber: 1,
        },
      });

      if (response.result) {
        setSearchResults(response.products);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error("Ürün araması yapılırken bir hata oluştu:", error);
    }
  };

  const searchComplain = async () => {
    if (!searchValue) setComplainResults([]);
    try {
      const response = await postFetcher(endpoints.complain.searchComplain, {
        arg: {
          searchText: searchValue,
        },
      });

      if (response.result) {
        setComplainResults(response.complains);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error("Ağrı araması yapılırken bir hata oluştu:", error);
    }
  };

  const handleClickCategory = async () => {
    if (type == "user") {
      try {
        const response = await getFetcher(endpoints.complain.allComplains);
        if (response?.result) {
          setAllComplains(response?.complainCategories);
          setShowCategory(true);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleMouseEnter = async (item: any) => {
    setSelectedCategory(item);
    setShowSubCategory(true);
    try {
      const response = await getFetcher(
        endpoints.complain.getComplainsById.replace("{id}", item?.id)
      );
      if (response?.result) {
        setSubCategories(response?.complains);
      } else {
        setSubCategories([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleMouseLeave = () => {
    setShowSubCategory(false);
  };

  React.useEffect(() => {
    searchFunc();
    searchComplain();
  }, [searchValue]);

  return (
    <div className={`relative w-full  lg:min-w-[570px]`}>
      <input
        className={`w-full border bg-[#EEF4FF] rounded-[30px] ${type === "user" ? "pl-[260px]" : "pl-[180px]"
          } pr-12 py-4  shadow-md shadow-gray-400 outline-none text-xs font-semibold placeholder:text-[13px] placeholder:text-gray-400`}
        placeholder={`${type === "user" ? t('mainSlider', 'placeholder2') : t('mainSlider', 'placeholder')
          }`}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
      />

      <div className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 flex  gap-x-1 items-center justify-between  pr-2 pl-2">
        {type === "user" ? (
          <FaRegUser className=" text-primary-color" />
        ) : (
          <img src={inputIcon} alt="..." className=" w-8 min-w-4 h-6" />
        )}

        <div
          onClick={handleClickCategory}
          className={` flex items-center gap-x-2  p-1 rounded-lg relative ${type == "user" ? "w-[220px]" : "w-auto"
            }  justify-between hover:cursor-pointer `}
        >
          <p className=" text-[13px] text-black font-poppins font-semibold cursor-pointer relative ">
            {type === "user" && t('mainSlider', 'inputCategories')}
            {type === "categories" && t('mainSlider', 'inputCategories')}
            {showCategory && (
              <div
                ref={dropdownRef}
                className=" absolute top-8 -left-8 min-w-[310px] sm:min-w-[260px] bg-[#EEF4FF] rounded shadow-2xl h-auto p-2"
              >
                {allComplains?.map((item: any, i: any) => {
                  return (
                    <div
                      key={i}
                      className=" flex items-center justify-between py-2 text-[#302842] transition-all "
                      onMouseEnter={() => handleMouseEnter(item)}
                      onMouseLeave={handleMouseLeave}
                    >
                      <div className=" flex gap-x-3 items-center">
                        <img className=" w-6 h-6" src={item?.image} alt="..." />
                        <p
                          onClick={() => navigate(`/complain/${item?.id}`)}
                          className=" font-semibold"
                        >
                          {item?.title}
                          {selectedCategory?.id === item?.id && (
                            <div className="relative">
                              {showSubCategory && (
                                <div className="absolute sm:-top-10 left-[20px] sm:left-[208px] w-[300px] p-4 bg-[#F8F8F8]  rounded shadow-lg">
                                  {subCategories?.map((sub: any, index: number) => {
                                    return (
                                      <div className=" px-3 text-[#141C3A] font-bold">
                                        <ul className=" list-disc">
                                          <li
                                            onClick={(e) => e.stopPropagation()}
                                            className=" list-item hover:underline"
                                          >
                                            <Link
                                              to={`/complain-detail?id=${item?.id}&index=${index}`}
                                              state={{
                                                complain: sub,
                                                mainId: sub?.id,
                                                mainTitle: sub?.title,
                                              }}
                                              className="w-full"
                                            >
                                              <p className="">{sub.title}</p>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </p>
                      </div>

                      <div className="">
                        <FaCaretRight size={18} />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </p>
          {type == "user" && (
            <div className=" border-r-2 h-8 flex items-center">
              <FiChevronDown />
            </div>
          )}
        </div>
      </div>

      <div className="absolute right-[8px] top-[51.5%] transform -translate-y-1/2 text-gray-500 ">
        <div
          className={`border p-2 rounded-full ${type === "user" ? "bg-yellow-color" : "bg-[#141C3A] cursor-pointer"
            }`}
          onClick={() => {
            if (type === "user")
              return
            else
              navigate(`/product-categories/${searchResults[0]?.subCategoryId}?subCatName=${"Aranılan Öğe: " + searchValue}`);
          }}
        >
          <LuSearch size={17} className=" text-white" />
        </div>
      </div>
      {type === "user" ? (
        complainResults.length < 1 ? (
          <></>
        ) : (
          <div className="pt-2 px-2 z-30 w-[90%] ml-[5%] bg-[#ebf2fe] shadow-md top-[45px] absolute ring-0 ">
            {complainResults.map((item: any, index) => {
              return (
                <Link
                  key={index}
                  to="/complain-detail"
                  state={{
                    complain: item,
                    mainId: item?.id,
                    mainTitle: item?.title,
                  }}
                  className="flex items-center mb-2 cursor-pointer justify-between "
                >
                  <p className="text-black m-2 text-[13px] relative">
                    {item.title}
                  </p>
                </Link>
              );
            })}
          </div>
        )
      ) : searchResults?.length < 1 ? (
        <></>
      ) : (
        <div className="pt-2 px-2 z-30 w-[90%] ml-[5%] bg-[#ebf2fe] shadow-md top-[45px] absolute">
          {searchResults.map((item: any, index: number) => {
            return (
              <div
                onClick={() => {
                  navigate(`/product-detail/${item.id}`);
                }}
                key={index}
                className="flex items-center mb-2 cursor-pointer"
              >
                <img
                  src={item.images[0]}
                  className="w-[40px] object-cover h-[40px] border rounded-md border-slate-500"
                ></img>
                <p className="text-black m-2 text-[13px]">{item.name}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SearchInput;
